export default __webpack_public_path__ + "static/accountancy-header-d5c2d21902c1ff10336ee0e6459cf962.jpg";